<template>
  <Modal
    v-model="_value"
    width="900"
    title="添加第三方监控订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
        <Form :model="monitoringServiceOrder" :rules="rules" :label-width="90">
          <Row>
            <Col span="8">
              <FormItem prop="registrationNum" label="车牌号码">
                <AutoComplete
                  @on-change="changedata3"
                  clearable
                  v-model="monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum"
                  :data="data3"
                  :filter-method="filterMethod"
                  @on-select="selectvehicle"
                  placeholder="请输入车牌号码"
                  style="width: 144.52px;">
                </AutoComplete>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="name" label="车牌颜色">
                <Select class="field" v-model="monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationColor">
                  <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="vin" label="车架号">
                <Input class="field" v-model="monitoringServiceOrder.monitoringServiceTempVehicleInfo.vin" placeholder="请输入车架号">
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="totalAmount" label="应收总金额">
                <InputNumber :min="0" class="field" v-model="monitoringServiceOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
              </FormItem>
            </Col>
            <Col span="8">
            <FormItem prop="serviceDateNum" label="服务期时长">
              <InputNumber :min="0" class="field" v-model="serviceDateNum" controls-outside @on-change="changeServiceDateNum"></InputNumber>
            </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="serviceDatetime" label="服务到期时间">
                <DatePicker class="field" type="date" v-model="monitoringServiceOrder.serviceDatetime"
                            placeholder="选择日期" @on-change="changeServiceDatetime"></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem prop="serviceDatetime" label="订单类型">
                <Select class="field" v-model="monitoringServiceOrder.monitoringServicePackage">
                  <Option v-for="item in monitoringServicePackageOptions" :value="item.value" :key="item.value">
                    {{item.label}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="businessUserId" label="跟进业务员">
                <Select class="field" v-model="monitoringServiceOrder.businessUserId">
                  <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem prop="billType" label="开票类型">
                <Select class="field" v-model="monitoringServiceOrder.billType">
                  <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
              </FormItem>
            </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="是否已收款">
                  <RadioGroup v-model="monitoringServiceOrder.receptDatetime">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="qghyptOption" label="是否加急">
                  <Space direction="vertical" size="large">
                    <RadioGroup v-model="monitoringServiceOrder.urgent">
                      <Radio label="是"></Radio>
                      <Radio label="否"></Radio>
                    </RadioGroup>
                  </Space>
                </FormItem>
              </Col>
            </Row>
            <Row>
            <Col span="12">
              <FormItem prop="clientInfoId" label="客户信息">
                <Select
                  placeholder="请选择客户名称"
                  v-model="monitoringServiceOrder.clientInfoId"
                  filterable
                  remote
                  :remote-method="searchClientInfo"
                  :loading="searchClientInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoBtn">添加客户信息</Button>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                <Select
                  placeholder="请选择车辆所有人名称"
                  v-model="monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId"
                  filterable
                  remote
                  :remote-method="searchVehicleOwnerInfo"
                  :loading="searchVehicleOwnerInfoLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem prop="vehicleInfoGroupId" label="预绑定车辆分组">
                <Select
                  placeholder="请选择车辆分组名称"
                  v-model="monitoringServiceOrder.vehicleInfoGroupId"
                  filterable
                  remote
                  :remote-method="searchVehicleInfoGroup"
                  :loading="searchVehicleInfoGroupLoading"
                  class="field" style="width: 60%;"
                  clearable>
                  <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                </Select>
                <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem prop="orderRemark" label="订单备注">
                <Input class="field" style="width: 80%;" v-model="monitoringServiceOrder.remark" type="textarea">
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
    <add-client-info-modal v-model="addClientInfoModal" :businessUserId="monitoringServiceOrder.businessUserId" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
  </Modal>
</template>
<script>

import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addmonitoringserviceordermodal',
  components: {
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal,
    AddVehicleOwnerInfoModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      searchVehicleInfoGroupList: [],
      searchVehicleInfoGroupLoading: false,

      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      // 第三方监控订单类型
      monitoringServicePackageOptions: [
        { label: '基础版', value: 1 },
        { label: '标准版', value: 2 },
        { label: '专业版', value: 3 }
      ],

      content: [],
      data3: [],
      list: [],

      businessUsers: [],
      isok: null,
      serviceDateNum: null,
      monitoringServiceOrder: {
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        monitoringServicePackage: 1,
        billType: 1,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        vehicleInfoId: null,
        reInstall: false,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        monitoringServiceTempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          salesChannelId: null,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_AddObj',
      'UserServ_GetAllUsers'
    ]),
    changeServiceDateNum (e) {
      // console.log(e)
      // console.log(new Date().getMonth())
      // console.log(new Date(new Date().setMonth(e)).Format('yyyy-MM-dd'))
      this.monitoringServiceOrder.serviceDatetime = new Date(new Date().setMonth(new Date().getMonth() + e)).Format('yyyy-MM-dd')
      console.log(this.monitoringServiceOrder.serviceDatetime)
    },
    changeServiceDatetime (e) {
      // console.log(e)
      // console.log(new Date(e))
      this.serviceDateNum = new Date(e).getMonth() - new Date().getMonth()
    },
    /**
     * 模糊查询车牌号
     */
    changedata3 () {
      this.content = []
      this.data3 = []
      if (!this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum || this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum === '') {
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: {
            name: this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum
          },
          urlparams: null
        }).then(res => {
          this.list = res.data

          // this.data3 = []
          let result = []
          for (let i = 0; i < this.list.length; i++) {
            let str = this.list[i].registrationNum === null ? this.list[i].vin : this.list[i].registrationNum
            if (str.toUpperCase().indexOf(this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum.toUpperCase()) !== -1) {
              result.push(str)
            }

            if (this.list[i].customName) {
              let str1 = this.list[i].customName
              if (str1.toUpperCase().indexOf(this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum.toUpperCase()) !== -1) {
                result.push(str1)
              }
            }
          }
          let length = result.length > 10 ? 10 : result.length
          for (let i = 0; i < length; i++) {
            this.data3.push(result[i])
          }
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      }
    },

    filterMethod () {
      this.onSearchClickdisabled = false

      return true
    },

    selectvehicle (e) {
      console.log(e)
      // this.onCheckClick(e)
      store.dispatch('VehicleInfoServ_SearchByName', {
        params: {
          name: e
        },
        urlparams: null
      }).then(res => {
        console.log(res)
        console.log(store.getters.get_VehicleInfo_SearchByNameResult)
        let vehicleinfo = null
        store.getters.get_VehicleInfo_SearchByNameResult.forEach(item => {
          if (e === item.registrationNum) {
            vehicleinfo = item
          } else {
            vehicleinfo = store.getters.get_VehicleInfo_SearchByNameResult[0]
          }
        })
        console.log(vehicleinfo)
        // let vehicleinfo = store.getters.get_VehicleInfo_SearchByNameResult[0]
        if (vehicleinfo) {
          this.content = []
          if (vehicleinfo) {
            if (vehicleinfo.positioningDeviceInfos) {
              vehicleinfo.positioningDeviceInfos.forEach(item => {
                this.content.push(item)
              })
            }
          } else {
            this.content = []
          }
          this.monitoringServiceOrder.vehicleInfoId = vehicleinfo.id

          this.monitoringServiceOrder.vehicleInfo.customName = vehicleinfo.customName
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.customName = vehicleinfo.customName
          this.monitoringServiceOrder.vehicleInfo.registrationNum = vehicleinfo.registrationNum
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum = vehicleinfo.registrationNum
          this.monitoringServiceOrder.vehicleInfo.registrationColor = vehicleinfo.registrationColor
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationColor = vehicleinfo.registrationColor
          this.monitoringServiceOrder.vehicleInfo.vin = vehicleinfo.vin
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vin = vehicleinfo.vin
          this.monitoringServiceOrder.vehicleInfo.bodyColor = vehicleinfo.bodyColor
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.bodyColor = vehicleinfo.bodyColor
          this.searchVehicleTypeList = []
          if (vehicleinfo.vehicleTypeId != null) {
            store.dispatch('VehicleTypeServ_GetDetail', {
              params: { id: vehicleinfo.vehicleTypeId },
              urlparams: null
            }).then(() => {
              this.searchVehicleTypeList.push(store.getters.get_VehicleType_GetDetailResult ? store.getters.get_VehicleType_GetDetailResult : [])
              this.searchVehicleTypeLoading = false
            }).catch(err => {
              this.searchVehicleTypeLoading = false
            })
            // this.monitoringServiceOrder.vehicleInfo.vehicleType.id = vehicleinfo.vehicleTypeId
            // this.monitoringServiceOrder.vehicleInfo.vehicleType.name = vehicleinfo.vehicleType.name
          } else {
            this.monitoringServiceOrder.vehicleInfo.vehicleType.id = null
            // this.monitoringServiceOrder.vehicleInfo.vehicleType.name = null
          }
          this.searchVehicleBrandList = []
          if (vehicleinfo.vehicleBrandId != null) {
            store.dispatch('VehicleBrandServ_GetDetail', {
              params: { id: vehicleinfo.vehicleBrandId },
              urlparams: null
            }).then(() => {
              this.searchVehicleBrandList.push(store.getters.get_VehicleBrand_GetDetailResult ? store.getters.get_VehicleBrand_GetDetailResult : [])
              this.searchVehicleBrandLoading = false
            }).catch(err => {
              this.searchVehicleBrandLoading = false
            })
            // this.monitoringServiceOrder.vehicleInfo.vehicleBrand.id = vehicleinfo.vehicleBrandId
            // this.monitoringServiceOrder.vehicleInfo.vehicleBrand.name = vehicleinfo.vehicleBrand.name
          } else {
            this.monitoringServiceOrder.vehicleInfo.vehicleBrand.id = null
            this.monitoringServiceOrder.vehicleInfo.vehicleBrand.name = null
          }
          this.monitoringServiceOrder.vehicleInfo.engineNum = vehicleinfo.engineNum
          this.monitoringServiceOrder.vehicleInfo.vehicleLicenseNum = vehicleinfo.vehicleLicenseNum
          this.monitoringServiceOrder.vehicleInfo.unladenMass = vehicleinfo.unladenMass
          this.monitoringServiceOrder.vehicleInfo.approvedLoad = vehicleinfo.approvedLoad
          this.searchVehicleOwnerInfoList = []
          if (vehicleinfo.vehicleOwnerInfoId != null) {
            store.dispatch('VehicleOwnerInfoServ_GetDetail', {
              params: {
                id: vehicleinfo.vehicleOwnerInfoId
              },
              urlparams: null
            }).then(res => {
              this.searchVehicleOwnerInfoList.push(store.getters.get_VehicleOwnerInfo_GetDetailResult ? store.getters.get_VehicleOwnerInfo_GetDetailResult : [])
              this.searchVehicleOwnerInfoLoading = false
            }).catch(err => {
              this.searchVehicleOwnerInfoLoading = false
              console.log(err)
            })
          }
          this.monitoringServiceOrder.vehicleInfo.vehicleOwnerInfoId = vehicleinfo.vehicleOwnerInfoId
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId = vehicleinfo.vehicleOwnerInfoId
          this.searchClientInfoList = []
          if (vehicleinfo.clientInfoId != null) {
            store.dispatch('ClientInfoServ_GetDetail', {
              params: { id: vehicleinfo.clientInfoId },
              urlparams: null
            }).then(() => {
              console.log(store.getters.get_ClientInfo_GetDetailResult)
              this.searchClientInfoList.push(store.getters.get_ClientInfo_GetDetailResult ? store.getters.get_ClientInfo_GetDetailResult : [])
              this.searchClientInfoLoading = false
            }).catch(err => {
              this.searchClientInfoLoading = false
            })
          }
          this.monitoringServiceOrder.vehicleInfo.clientInfoId = vehicleinfo.clientInfoId
          this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.clientInfoId = vehicleinfo.clientInfoId
          this.monitoringServiceOrder.vehicleInfo.servicePassword = vehicleinfo.servicePassword
          this.monitoringServiceOrder.vehicleInfo.vehicleLicenseDistributeDatetime = vehicleinfo.vehicleLicenseDistributeDatetime
          this.monitoringServiceOrder.vehicleInfo.vehicleLicenseReigsterDatetime = vehicleinfo.vehicleLicenseReigsterDatetime
          this.monitoringServiceOrder.vehicleInfo.remark = vehicleinfo.remark
          this.monitoringServiceOrder.vehicleInfo.certificateNum = vehicleinfo.certificateNum
          this.monitoringServiceOrder.vehicleInfo.certificateDistributeDatetime = vehicleinfo.certificateDistributeDatetime
          if (vehicleinfo.vehicleModelId != null) {
            this.monitoringServiceOrder.vehicleInfo.vehicleModel.id = vehicleinfo.vehicleModelId
            // this.monitoringServiceOrder.vehicleInfo.vehicleModel.name = vehicleinfo.vehicleModel.name
          } else {
            this.monitoringServiceOrder.vehicleInfo.vehicleModel.id = null
            this.monitoringServiceOrder.vehicleInfo.vehicleModel.name = null
          }
          this.monitoringServiceOrder.vehicleInfo.chassisModel = vehicleinfo.chassisModel
          this.monitoringServiceOrder.vehicleInfo.chassisId = vehicleinfo.chassisId
          this.monitoringServiceOrder.vehicleInfo.chassisCertificateNum = vehicleinfo.chassisCertificateNum
          this.monitoringServiceOrder.vehicleInfo.engineModel = vehicleinfo.engineModel
          this.monitoringServiceOrder.vehicleInfo.energyType = vehicleinfo.energyType
          this.monitoringServiceOrder.vehicleInfo.displacement = vehicleinfo.displacement
          this.monitoringServiceOrder.vehicleInfo.power = vehicleinfo.power
          this.monitoringServiceOrder.vehicleInfo.energyUsage = vehicleinfo.energyUsage
          this.monitoringServiceOrder.vehicleInfo.emissionStandard = vehicleinfo.emissionStandard
          this.monitoringServiceOrder.vehicleInfo.manufacturer = vehicleinfo.manufacturer
          this.monitoringServiceOrder.vehicleInfo.outlineSizeLong = vehicleinfo.outlineSizeLong
          this.monitoringServiceOrder.vehicleInfo.outlineSizeWidth = vehicleinfo.outlineSizeWidth
          this.monitoringServiceOrder.vehicleInfo.outlineSizeHeight = vehicleinfo.outlineSizeHeight
          this.monitoringServiceOrder.vehicleInfo.boxSizeLong = vehicleinfo.boxSizeLong
          this.monitoringServiceOrder.vehicleInfo.boxSizeWidth = vehicleinfo.boxSizeWidth
          this.monitoringServiceOrder.vehicleInfo.boxSizeHeight = vehicleinfo.boxSizeHeight
          this.monitoringServiceOrder.vehicleInfo.springPieceCount = vehicleinfo.springPieceCount
          this.monitoringServiceOrder.vehicleInfo.tyreCount = vehicleinfo.tyreCount
          this.monitoringServiceOrder.vehicleInfo.tyreSpec = vehicleinfo.tyreSpec
          this.monitoringServiceOrder.vehicleInfo.wheelSpanFront = vehicleinfo.wheelSpanFront
          this.monitoringServiceOrder.vehicleInfo.wheelSpanBack = vehicleinfo.wheelSpanBack
          this.monitoringServiceOrder.vehicleInfo.wheelBase = vehicleinfo.wheelBase
          this.monitoringServiceOrder.vehicleInfo.axisLoad = vehicleinfo.axisLoad
          this.monitoringServiceOrder.vehicleInfo.axisCount = vehicleinfo.axisCount
          this.monitoringServiceOrder.vehicleInfo.turnType = vehicleinfo.turnType
          this.monitoringServiceOrder.vehicleInfo.totalMass = vehicleinfo.totalMass
          this.monitoringServiceOrder.vehicleInfo.approvedLoadCoefficient = vehicleinfo.approvedLoadCoefficient
          this.monitoringServiceOrder.vehicleInfo.towMax = vehicleinfo.towMax
          this.monitoringServiceOrder.vehicleInfo.saddleMax = vehicleinfo.saddleMax
          this.monitoringServiceOrder.vehicleInfo.cabPeopleCount = vehicleinfo.cabPeopleCount
          this.monitoringServiceOrder.vehicleInfo.mannedCount = vehicleinfo.mannedCount
          this.monitoringServiceOrder.vehicleInfo.speedMax = vehicleinfo.speedMax
          this.monitoringServiceOrder.vehicleInfo.productionDatetime = vehicleinfo.productionDatetime
          this.monitoringServiceOrder.vehicleInfo.certificateRemark = vehicleinfo.certificateRemark
          this.monitoringServiceOrder.vehicleInfo.vehicleLicensePictureId = vehicleinfo.vehicleLicensePictureId
          this.monitoringServiceOrder.vehicleInfo.certificatePictureId = vehicleinfo.certificatePictureId
          this.monitoringServiceOrder.vehicleInfo.vehicleSrcLicensePicture1Id = vehicleinfo.vehicleSrcLicensePicture1Id
          this.monitoringServiceOrder.vehicleInfo.vehicleSrcLicensePicture2Id = vehicleinfo.vehicleSrcLicensePicture2Id
          this.monitoringServiceOrder.vehicleInfo.vehicleBodyPictureId = vehicleinfo.vehicleBodyPictureId
          this.monitoringServiceOrder.vehicleInfo.test = false
          this.monitoringServiceOrder.vehicleInfo.vehicleUse = vehicleinfo.vehicleUse
          this.monitoringServiceOrder.vehicleInfo.attention = vehicleinfo.attention

          this.monitoringServiceOrder.businessUserId = vehicleinfo.businessUserId
          this.monitoringServiceOrder.clientInfoId = vehicleinfo.clientInfoId
          this.searchVehicleInfoGroupList = []
          if (vehicleinfo.vehicleInfoGroupId != null) {
            store.dispatch('VehicleInfoGroupServ_GetDetail', {
              params: { id: vehicleinfo.vehicleInfoGroupId },
              urlparams: null
            }).then(() => {
              this.searchVehicleInfoGroupList.push(store.getters.get_VehicleInfoGroup_GetDetailResult ? store.getters.get_VehicleInfoGroup_GetDetailResult : [])
              this.searchVehicleInfoGroupLoading = false
            }).catch(err => {
              this.searchVehicleInfoGroupLoading = false
            })
          }
          this.monitoringServiceOrder.vehicleInfoGroupId = vehicleinfo.vehicleInfoGroupId

          console.log(this.monitoringServiceOrder)
        }
      }).catch(err => {
        console.log(err)
        this.$Message.error(err)
      })
    },

    // onDeviceAndFittings () {
    // },
    // onCheckClick(){
    //   console.log('查询运营资格')
    //   console.log(this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum)
    //   store.dispatch('VehicleInfoServ_InquireOperation',{
    //     params:{
    //       registrationNum : this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum
    //     }
    //   }).then(res=>{
    //     console.log(store.getters.get_VehicleInfo_InquireOperationResult)
    //     if (store.getters.get_VehicleInfo_InquireOperationResult) {
    //     this.isok=true
    //     }else {
    //       this.isok=false
    //     }
    //   }).catch(err=>{
    //   this.isok=false
    //     console.log(err)
    //     this.$Message.error(err)
    //   })
    // },
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAddClientInfoBtn () {
      if (!this.monitoringServiceOrder.businessUserId) {
        this.$Message.error('请先选择跟进业务员')
        return
      }
      this.addClientInfoModal = true
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onSuccess () {

    },
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchVehicleInfoGroup (input) {
      this.searchVehicleInfoGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoGroupList = []
        this.searchVehicleInfoGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchVehicleInfoGroupLoading = false
        }).catch(err => {
          this.searchVehicleInfoGroupLoading = false
        })
      }
    },
    searchSalesChannel (input) {
      this.searchSalesChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchSalesChannelList = []
        this.searchSalesChannelLoading = false
      } else {
        store.dispatch('SalesChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
          this.searchSalesChannelLoading = false
        }).catch(err => {
          this.searchSalesChannelLoading = false
        })
      }
    },
    searchClientInfo (input) {
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    onOk () {
      // console.log(this.monitoringServiceOrder)
      if (this.monitoringServiceOrder.receptDatetime == '是') {
        this.monitoringServiceOrder.receptDatetime = new Date()
      } else {
        this.monitoringServiceOrder.receptDatetime = null
      }
      if (this.monitoringServiceOrder.urgent == '是') {
        this.monitoringServiceOrder.urgent = true
      } else {
        this.monitoringServiceOrder.urgent = false
      }
      this.$Modal.confirm({
        title: '添加第三方监控订单信息',
        content: '<p>添加第三方监控订单信息</p>',
        onOk: () => {
          store.dispatch('MonitoringServiceOrderServ_AddObj', { params: this.monitoringServiceOrder }).then(() => {
            this.$Message.success('添加第三方监控订单信息')
            this.cleanData()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.isok = null
        this.cleanData()
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    cleanData () {
      this.searchVehicleInfoGroupList = []
      this.searchVehicleOwnerInfoList = []
      this.searchClientInfoList = []
      /**
       * 清除监控订单临时车辆信息
       */
      this.monitoringServiceOrder.clientInfoId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.customName = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationNum = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.registrationColor = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vin = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.bodyColor = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleType.name = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.engineNum = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseNum = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.unladenMass = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.approvedLoad = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.clientInfoId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.servicePassword = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseDistributeDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseReigsterDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.remark = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.certificateNum = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.certificateDistributeDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.chassisModel = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.chassisId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.chassisCertificateNum = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.engineModel = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.energyType = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.displacement = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.power = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.energyUsage = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.emissionStandard = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.manufacturer = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.outlineSizeLong = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.outlineSizeWidth = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.outlineSizeHeight = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.boxSizeLong = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.boxSizeWidth = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.boxSizeHeight = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.springPieceCount = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.tyreCount = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.tyreSpec = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.wheelSpanFront = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.wheelSpanBack = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.wheelBase = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.axisLoad = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.axisCount = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.turnType = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.totalMass = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.approvedLoadCoefficient = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.towMax = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.saddleMax = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.cabPeopleCount = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.mannedCount = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.speedMax = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.productionDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.certificateRemark = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleLicensePictureId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.certificatePictureId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture1Id = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture2Id = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleBodyPictureId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.test = false
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.vehicleUse = null
      this.monitoringServiceOrder.salesChannelId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.mliftainsuranceChannelId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.mliftainsurancechannelDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.tiinsuranceChannelId = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.tiinsurancechannelDatetime = null
      this.monitoringServiceOrder.monitoringServiceTempVehicleInfo.insured = null

      /**
       * 清除监控订单车辆信息
       */
      this.monitoringServiceOrder.clientInfoId = null
      this.monitoringServiceOrder.vehicleInfoId = null
      this.monitoringServiceOrder.vehicleInfoGroupId = null

      this.monitoringServiceOrder.vehicleInfo.customName = null
      this.monitoringServiceOrder.vehicleInfo.registrationNum = null
      this.monitoringServiceOrder.vehicleInfo.registrationColor = null
      this.monitoringServiceOrder.vehicleInfo.vin = null
      this.monitoringServiceOrder.vehicleInfo.bodyColor = null
      this.monitoringServiceOrder.vehicleInfo.vehicleType.name = null
      this.monitoringServiceOrder.vehicleInfo.vehicleBrand.name = null
      this.monitoringServiceOrder.vehicleInfo.engineNum = null
      this.monitoringServiceOrder.vehicleInfo.vehicleLicenseNum = null
      this.monitoringServiceOrder.vehicleInfo.unladenMass = null
      this.monitoringServiceOrder.vehicleInfo.approvedLoad = null
      this.monitoringServiceOrder.vehicleInfo.vehicleOwnerInfoId = null
      this.monitoringServiceOrder.vehicleInfo.clientInfoId = null
      this.monitoringServiceOrder.vehicleInfo.servicePassword = null
      this.monitoringServiceOrder.vehicleInfo.vehicleLicenseDistributeDatetime = null
      this.monitoringServiceOrder.vehicleInfo.vehicleLicenseReigsterDatetime = null
      this.monitoringServiceOrder.vehicleInfo.remark = null
      this.monitoringServiceOrder.vehicleInfo.certificateNum = null
      this.monitoringServiceOrder.vehicleInfo.certificateDistributeDatetime = null
      this.monitoringServiceOrder.vehicleInfo.vehicleModel.name = null
      this.monitoringServiceOrder.vehicleInfo.chassisModel = null
      this.monitoringServiceOrder.vehicleInfo.chassisId = null
      this.monitoringServiceOrder.vehicleInfo.chassisCertificateNum = null
      this.monitoringServiceOrder.vehicleInfo.engineModel = null
      this.monitoringServiceOrder.vehicleInfo.energyType = null
      this.monitoringServiceOrder.vehicleInfo.displacement = null
      this.monitoringServiceOrder.vehicleInfo.power = null
      this.monitoringServiceOrder.vehicleInfo.energyUsage = null
      this.monitoringServiceOrder.vehicleInfo.emissionStandard = null
      this.monitoringServiceOrder.vehicleInfo.manufacturer = null
      this.monitoringServiceOrder.vehicleInfo.outlineSizeLong = null
      this.monitoringServiceOrder.vehicleInfo.outlineSizeWidth = null
      this.monitoringServiceOrder.vehicleInfo.outlineSizeHeight = null
      this.monitoringServiceOrder.vehicleInfo.boxSizeLong = null
      this.monitoringServiceOrder.vehicleInfo.boxSizeWidth = null
      this.monitoringServiceOrder.vehicleInfo.boxSizeHeight = null
      this.monitoringServiceOrder.vehicleInfo.springPieceCount = null
      this.monitoringServiceOrder.vehicleInfo.tyreCount = null
      this.monitoringServiceOrder.vehicleInfo.tyreSpec = null
      this.monitoringServiceOrder.vehicleInfo.wheelSpanFront = null
      this.monitoringServiceOrder.vehicleInfo.wheelSpanBack = null
      this.monitoringServiceOrder.vehicleInfo.wheelBase = null
      this.monitoringServiceOrder.vehicleInfo.axisLoad = null
      this.monitoringServiceOrder.vehicleInfo.axisCount = null
      this.monitoringServiceOrder.vehicleInfo.turnType = null
      this.monitoringServiceOrder.vehicleInfo.totalMass = null
      this.monitoringServiceOrder.vehicleInfo.approvedLoadCoefficient = null
      this.monitoringServiceOrder.vehicleInfo.towMax = null
      this.monitoringServiceOrder.vehicleInfo.saddleMax = null
      this.monitoringServiceOrder.vehicleInfo.cabPeopleCount = null
      this.monitoringServiceOrder.vehicleInfo.mannedCount = null
      this.monitoringServiceOrder.vehicleInfo.speedMax = null
      this.monitoringServiceOrder.vehicleInfo.productionDatetime = null
      this.monitoringServiceOrder.vehicleInfo.certificateRemark = null
      this.monitoringServiceOrder.vehicleInfo.vehicleLicensePictureId = null
      this.monitoringServiceOrder.vehicleInfo.certificatePictureId = null
      this.monitoringServiceOrder.vehicleInfo.vehicleSrcLicensePicture1Id = null
      this.monitoringServiceOrder.vehicleInfo.vehicleSrcLicensePicture2Id = null
      this.monitoringServiceOrder.vehicleInfo.vehicleBodyPictureId = null
      this.monitoringServiceOrder.vehicleInfo.test = false
      this.monitoringServiceOrder.vehicleInfo.vehicleUse = null
      this.monitoringServiceOrder.salesChannelId = null
      this.monitoringServiceOrder.vehicleInfo.mliftainsuranceChannelId = null
      this.monitoringServiceOrder.vehicleInfo.mliftainsurancechannelDatetime = null
      this.monitoringServiceOrder.vehicleInfo.tiinsuranceChannelId = null
      this.monitoringServiceOrder.vehicleInfo.tiinsurancechannelDatetime = null
      this.monitoringServiceOrder.vehicleInfo.insured = null
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
